module.exports = __webpack_public_path__ + "img/epic-badge.ddc1eebe.png";